import { Col, Row } from "react-bootstrap";
import { fadeIn } from "../../Functions/GlobalAnimations";
import { m } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { getVideoGallery } from "../../Store/Publication/gallery";
import Loading from "../../Components/Loading";

const VideoGallery = () => {
  const { data: video, isLoading } = useQuery({
    queryKey: ["videoGallery"],
    queryFn: () => getVideoGallery(),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
  if (isLoading) return <Loading />;

  return (
    <>
      <m.div className="container mt-[200px]">
        <Col xl={8} lg={10} className="text-start w-fit">
          <h3 className="font-serif text-[30px] mb-[2px] font-medium text-[#146084] ">
            Video Gallery
          </h3>
          <m.div
            className="border-b border-1 w-[40%] border-[#146084]"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          />
          <p className="text-[16px] text-[#666] mt-4">
            Watch videos showcasing KERA's initiatives, training programs, and
            success stories
          </p>
        </Col>

        <Row className="mt-[100px]">
          {video?.data?.map((item, index) => (
            <Col lg={4} md={6} sm={12} key={index} className="mb-[30px]">
              <m.div
                {...fadeIn}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-lg overflow-hidden cursor-pointer"
                onClick={() => {
                  // open youtube video in new tab
                  window.open(item.url, "_blank");
                }}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={`https://kera.enfonoerp.com/${item?.image}`}
                    alt={item.title}
                    className="w-full h-[250px] object-cover hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <p className="text-[14px] text-[#666] leading-relaxed mb-3 line-clamp-3">
                  {item.description}
                </p>
              </m.div>
            </Col>
          ))}
        </Row>
      </m.div>
    </>
  );
};

export default VideoGallery;
